export default __webpack_public_path__ + "static/illustration-new-zealand.url-75144c38db802928c8d82a43f8b4fe6a.svg";